import { EventCategory, EventSubCategory } from "@/types/events";
export const categoryToLabel = (category) => {
    const labels = {
        [EventCategory.NIVEL_RIOS]: "Nível dos Rios",
        [EventCategory.AREA_ALAGAMENTO]: "Área de Alagamento",
        [EventCategory.CHUVAS]: "Chuvas",
        [EventCategory.BARRAGENS]: "Barragens",
        [EventCategory.VENDAVAL]: "Vendaval",
        [EventCategory.INCENDIO]: "Incêndio",
        [EventCategory.PERDA_SOLO]: "Perda de solo",
        [EventCategory.DESLIZAMENTO]: "Deslizamento",
        [EventCategory.PRODUTOS_QUIMICOS]: "Produtos químicos",
        [EventCategory.TREMOR]: "Tremor de terra",
    };
    return labels[category];
};
export const subCategoryToLabel = (category) => {
    const labels = {
        // NÍVEL DOS RIOS
        [EventSubCategory.BAIXO]: "Baixo",
        [EventSubCategory.ALTO]: "Alto",
        [EventSubCategory.TRANSBORDANDO]: "Transbordando",
        // ÁREA DE ALAGAMENTO
        [EventSubCategory.TRANSITAVEL]: "Transitável",
        [EventSubCategory.INTRANSITAVEL]: "Intransitável",
        // CHUVAS
        [EventSubCategory.CHUVA_FRACA]: "Chuva fraca",
        [EventSubCategory.CHUVA_MODERADA]: "Chuva moderada",
        [EventSubCategory.CHUVA_FORTE]: "Chuva forte",
        [EventSubCategory.ENXURRADA]: "Enxurrada",
        [EventSubCategory.DANOS_ESTRUTURA]: "Danos à estrutura",
        [EventSubCategory.PERDA_SOLO]: "Perda de solo",
        // BARRAGENS
        [EventSubCategory.TRINCA]: "Trinca",
        [EventSubCategory.FISSURA]: "Fissura",
        [EventSubCategory.FUGA_AGUA]: "Fuga de água",
        [EventSubCategory.VAZAMENTO]: "Vazamento",
        [EventSubCategory.CRESCIMENTO_VEGETACAO]: "Crescimento de vegetação",
        [EventSubCategory.OCUPACAO]: "Ocupação",
        [EventSubCategory.CONSTRUCAO_IRREGULAR]: "Construção irregular",
        // VENDAVAL
        [EventSubCategory.QUEDA_ARVORES]: "Queda de árvores",
        [EventSubCategory.DANOS_REDE_ELETRICA]: "Danos à rede elétrica",
        [EventSubCategory.DANOS_RESIDENCIAS]: "Danos às residências",
        // INCÊNDIOS
        [EventSubCategory.RISCO_VIDA]: "Risco à vida",
        [EventSubCategory.PREJUIZO_MATERIAL]: "Prejuízo material",
        [EventSubCategory.DEGRADACAO_AMBIENTAL]: "Degradação ambiental",
        [EventSubCategory.IMPACTOS_SAUDE_PUBLICA]: "Impactos à saúde pública",
        // DESLIZAMENTO
        [EventSubCategory.DANOS_HUMANOS]: "Danos humanos",
        [EventSubCategory.DANOS_MATERIAIS]: "Danos materiais",
        [EventSubCategory.DANOS_AMBIENTAIS]: "Danos ambientais",
        // PRODUTOS QUÍMICOS
        [EventSubCategory.AGUA]: "Água",
        [EventSubCategory.AR]: "Ar",
        [EventSubCategory.SOLO]: "Solo",
    };
    return labels[category];
};
export const categorySubtitleVariant = (category) => {
    const variant = {
        [EventCategory.NIVEL_RIOS]: "nível dos rios",
        [EventCategory.AREA_ALAGAMENTO]: "alagamentos",
        [EventCategory.CHUVAS]: "chuvas",
        [EventCategory.BARRAGENS]: "barragens",
        [EventCategory.VENDAVAL]: "vendavais",
        [EventCategory.INCENDIO]: "incêndios",
        [EventCategory.PERDA_SOLO]: "perda de solo",
        [EventCategory.PRODUTOS_QUIMICOS]: "produtos químicos",
        [EventCategory.DESLIZAMENTO]: "deslizamentos",
        [EventCategory.TREMOR]: "tremor de terra",
    };
    return variant[category];
};
const categoryMap = {
    "nivel-rios": EventCategory.NIVEL_RIOS,
    "area-alagamento": EventCategory.AREA_ALAGAMENTO,
    chuvas: EventCategory.CHUVAS,
    barragens: EventCategory.BARRAGENS,
    vendaval: EventCategory.VENDAVAL,
    incendio: EventCategory.INCENDIO,
    deslizamento: EventCategory.DESLIZAMENTO,
    "perda-solo": EventCategory.PERDA_SOLO,
    tremor: EventCategory.TREMOR,
    "produtos-quimicos": EventCategory.PRODUTOS_QUIMICOS,
};
export function categoryFromUrl(category) {
    return categoryMap[category.toLowerCase()];
}
